import React, { useState, useRef } from "react";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import { validaSoloNumero } from "../../util/varios";
import CatalogoPlanCuenta from "../../catalogos/catalogoPlanCuenta";

import { Input, SearchInput, Select, Textarea } from "../../ui/inputs/Input";
import {
  DangerButton,
  InfoButton,
  PrimaryButton,
  SuccessButton,
  WarningButton,
} from "../../ui/buttons/Button";

const TablaCatalogoCuentaContable = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  let inputElement = document.getElementById("codigocuenta");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const btnAcepta = useRef();

  const txtId = useRef();
  const txtDescripcion = useRef();
  const cmbTipo = useRef();
  const txtDeducible = useRef();
  const txtOtroPorcen = useRef();
  const txtCuentaContable = useRef();
  const cmbNaturaleza = useRef();
  const cmbTipoPago = useRef();
  const cmbTipoRecurso = useRef();

  const [operacion, setOperacion] = useState(0);

  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [visibleId, setVisibleId] = useState("visible");
  const [visibleOtro, setVisibleOtro] = useState("collapse");
  const [visibleISLR, setVisibleISLR] = useState("hidden");
  const [tituloHeader, setTituloHeader] = useState(
    "Gestionar Cuentas Contables."
  );

  const [habilitado, setHabilitado] = useState(true);
  const [catalogoCuenta, setCatalogoCuenta] = useState(false);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);

  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoBene: true,
  });
  const [values, setValues] = useState({
    idplancuenta: "",
    codigocuenta: "",
    descripcion: "",
    idefiscal: "",
    cargable: "",
    naturaleza: "",
    tipopago: "",
    tiporecurso: "",
  });

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    setValues({
      ...values,
      [inputElement.name]: maskIt("00-000-00-00-000", event.target.value),
    });
    txtCuentaContable.current.value = maskIt(
      "00-000-00-00-000",
      event.target.value
    );

    if (event.which === 46) {
      return false;
    } else if (
      (event.which >= 48 && event.which <= 57) ||
      (event.which >= 96 && event.which <= 105)
    ) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };
  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const blanquear = () => {
    txtCuentaContable.current.value = "";
    txtId.current.setAttribute("disabled", true);
    setOperacion(0);
    setTituloHeader("Gestionar Cuentas Contables.");
    setVisibleISLR("hidden");
    setVisibleOtro("collapse");
    setVisibleBtn("visible");
    setVisibleId("visible");

    setValues({
      idplancuenta: "",
      codigocuenta: "",
      descripcion: "",
      idefiscal: "",
      cargable: "",
      naturaleza: "",
      tipopago: "",
      tiporecurso: "",
    });
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoBene: true,
    });

    txtId.current.value = "";
    txtDescripcion.current.value = "";

    cmbTipo.current.value = "";

    setActivate(false);
    setHabilitado(true);
    setHabilitadoNU(true);
    setOperacion(0);
  };

  const procesarRegistro = () => {
    setActivate(true);
    /* let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    } */
    let endpoint = `${op.conexion}/api/contabilidadfis/actualizarplancuenta`;

    let body;
    let codig = txtCuentaContable.current.value.trim().replace("-", "");

    body = {
      operacion: operacion,
      nid: values.idplancuenta === "" ? 0 : values.idplancuenta,
      codigo: codig.replace("-", "").replace("-", "").replace("-", ""),
      descri: values.descripcion.toUpperCase(),
      carga: parseInt(values.cargable) === 0 ? true : false,
      idefi: idefiscal,
      natu: parseInt(values.naturaleza),
      tippago: parseInt(values.tipopago),
      tiprecu: parseInt(values.tiporecurso),
    };

    console.log(body);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }

          blanquear();

          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "ubicacion_key"'
          ) {
            mensaje = "Ya existe un Registro";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const onChange = (event) => {
    if (event.target.name === "descripcion") {
      event.target.value = event.target.value;
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "unidad") {
      if (event.target.value === "4") {
        setVisibleOtro("visible");
      } else {
        setVisibleOtro("collapse");
        txtOtroPorcen.current.value = "";
      }
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "tipo") {
      if (event.target.value === "1") {
        setVisibleISLR("visible");
      } else {
        setVisibleISLR("hidden");
        txtDeducible.current.value = "";
      }
      setValues({ ...values, [event.target.name]: event.target.value });
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  };

  const seleccionarRegistroPLanCuenta = (id) => {
    let campos = "*";
    let nomtab = "plancuenta";
    let nomid = "idplancuenta";
    let condic = "idefiscal = " + idefiscal;
    let endpoint = `${
      op.conexion
    }/api/consulta/modelicondi?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${parseInt(id)}&condic=${condic}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            txtId.current.value = response.data[0].idplancuenta;
            txtCuentaContable.current.value =
              response.data[0].codigocuenta.substring(0, 2) +
              "-" +
              response.data[0].codigocuenta.substring(2, 5) +
              "-" +
              response.data[0].codigocuenta.substring(5, 7) +
              "-" +
              response.data[0].codigocuenta.substring(7, 9) +
              "-" +
              response.data[0].codigocuenta.substring(9, 12);
            txtDescripcion.current.value = response.data[0].descripcion.trim();
            cmbTipo.current.value = response.data[0].cargable ? 0 : 1;
            cmbNaturaleza.current.value = response.data[0].naturaleza;
            cmbTipoPago.current.value = response.data[0].tipopago;
            cmbTipoRecurso.current.value = response.data[0].tiporecurso; 
            setValues(response.data[0]);
            if (operacion === 2) {
              setHabilitado(false);
              txtCuentaContable.current.focus();
            }
            if (operacion !== 4) {
              botones.aceptar = false;;
            }
            txtId.current.setAttribute("disabled", true);
            botones.catalogo = true;
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una Cuenta Contable con este Codigo.",
              icono: "informacion",
            });
            txtId.current.value = "";
            txtDescripcion.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarPlancuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistroPLanCuenta(event.target.value);
      } else {
        setValues({
          idplancuenta: "",
          codigocuenta: "",
          descripcion: "",
          idefiscal: "",
          cargable: "",
          naturaleza: "",
          tipopago: "",
          tiporecurso: "",
        });
        cmbTipo.current.value = "";
        txtCuentaContable.current.value = "";
        txtDescripcion.current.value = "";
      }
    }
  };

  const onCatalogoPlanCuenta = (value) => {
    setCatalogoCuenta(false);
    seleccionarRegistroPLanCuenta(value.idplancuenta);

    if (!botones.modificar) {
      setBotones({ ...botones, catalogoBene: false });
    }
  };
  const onChangeValidar = () => {
    let sigue = true;
    //if (!botones.incluir || !botones.modificar) {
      if (txtCuentaContable.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Codigo Cuenta Contable.",
          icono: "informacion",
        });
        sigue = false;
        txtCuentaContable.current.focus();
      } else if (txtDescripcion.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar Una Descripción.",
          icono: "informacion",
        });
        sigue = false;
        txtDescripcion.current.focus();
      } else if (cmbTipo.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar la Carga.",
          icono: "informacion",
        });
        sigue = false;
        cmbTipo.current.focus();
      } else if (cmbNaturaleza.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar la Naturaleza.",
          icono: "informacion",
        });
        sigue = false;
        cmbNaturaleza.current.focus();
      } else if (cmbTipoPago.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar un Tipo de Pago.",
          icono: "informacion",
        });
        sigue = false;
        cmbTipoPago.current.focus();
      } else if (cmbTipoRecurso.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar un Tipo de Recurso.",
          icono: "informacion",
        });
        sigue = false;
        cmbTipoRecurso.current.focus();
      }
    //}
    if (sigue) {
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };
  const onBotones = (op) => (e) => {
    
    if (op === 1 || op === 2 || op === 3 || op === 4) {
      setVisibleBtn("hidden");
    } else if (op === 6) {
      setVisibleBtn("visible");
    }
    e.preventDefault();

    if (op === 1) {
      setOperacion(op);
      setVisibleId("hidden");
      setTituloHeader("Incluir Cuentas Contables.");
      setHabilitado(false);
      setBotones({
        incluir: false,
        consultar: true,
        modificar: true,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: true,
        catalogoBene: false,
      });
      txtCuentaContable.current.removeAttribute("disabled");

      txtCuentaContable.current.focus();
    } else if (op === 2) {
      setOperacion(op);
      setTituloHeader("Editar Cuentas Contables.");

      setHabilitado(true);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: true,
        eliminar: true,
        aceptar: true,
        cancelar: false,
        catalogo: false,
        catalogoBene: true,
      });
      txtId.current.removeAttribute("disabled");

      txtId.current.focus();
    } else if (op === 3) {
      setOperacion(op);
      setTituloHeader("Eliminar Cuentas Contables.");

      setHabilitado(true);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: true,
        eliminar: true,
        aceptar: true,
        cancelar: false,
        catalogo: false,
        catalogoBene: true,
      });
      txtId.current.removeAttribute("disabled");

      txtId.current.focus();
    } else if (op === 4) {
      setOperacion(op);
      setTituloHeader("Consultar Cuentas Contables.");

      setHabilitado(true);
      txtId.current.focus();
      setBotones({
        incluir: true,
        consultar: true,
        modificar: true,
        eliminar: true,
        aceptar: true,
        cancelar: false,
        catalogo: false,
        catalogoBene: true,
      });
      txtId.current.removeAttribute("disabled");

      txtId.current.focus();
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    }
  };

  function maskIt(pattern, value) {
    let position = 0;
    let currentChar = 0;
    let masked = "";
    while (position < pattern.length && currentChar < value.length) {
      if (pattern[position] === "0") {
        masked += value[currentChar];
        currentChar++;
      } else {
        masked += pattern[position];
      }
      position++;
    }
    return masked;
  }
  const cerrar = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-2 border rounded">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
        <h3 className="fw-bold m-0">{tituloHeader}</h3>
        <a type="button" onClick={cerrar} className="text-light fw-bold">
          Salir <i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-12 m-0 my-2 p-0 d-flex flex-wrap">
        <div className="col-4 mb-2 p-0 pr-2" style={{ visibility: visibleId }}>
          <SearchInput
            label="Código:"
            name="idcuentabancaria"
            disabled={habilitadoNU}
            defaultValue={
              values.idplancuenta !== null || values.idplancuenta !== ""
                ? values.idplancuenta.trim()
                : ""
            }
            onKeyUp={validarPlancuenta}
            onBlur={validarPlancuenta}
            onClickButton={() => {
              setCatalogoCuenta(true);
            }}
            disabledButton={botones.catalogo}
            ref={txtId}
          />
        </div>
        <div className="col-12 mb-2 p-0">
          <Input
            label="Cuenta Contable:"
            disabled={habilitado}
            id="codigocuenta"
            name="codigocuenta"
            maxLength={16}
            minLength={16}
            onKeyUp={handleInputNumChange}
            onChange={handleInputNumChange}
            ref={txtCuentaContable}
          />
        </div>
        <div className="col-12 mb-2 p-0">
          <Textarea
            label="Descripción:"
            style={{ height: 60 }}
            disabled={habilitado}
            name="descripcion"
            onChange={onChange}
            ref={txtDescripcion}
          />
        </div>
        <div className="col-2 mb-2 p-0 pr-2">
          <Select
            label="Cargable:"
            name="cargable"
            id="cargable"
            onChange={onChange}
            disabled={habilitado}
            ref={cmbTipo}
          >
            <option value=""> Seleccione</option>
            <option value="0">Si</option>
            <option value="1">No</option>
          </Select>
        </div>
        <div className="col-4 mb-2 p-0">
          <Select
            label="Naturaleza de la Cuenta:"
            value={values.naturaleza}
            name="naturaleza"
            id="naturaleza"
            onChange={onChange}
            disabled={habilitado}
            ref={cmbNaturaleza}
          >
            <option value=""> Seleccione</option>
            <option value="1"> Acreedora</option>
            <option value="2">Deudora</option>
          </Select>
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Select
            label="Tipo Pago:"
            name="tipopago"
            value={values.tipopago}
            id="tipopago"
            onChange={onChange}
            disabled={habilitado}
            ref={cmbTipoPago}
          >
            <option value=""> Seleccione</option>
            <option value="5"> Orden Compra</option>
            <option value="7">Pago de Obra</option>
            <option value="11">Orden Servicio</option>
            <option value="12">Pago Directo</option>
            <option value="13">Pago Nomina</option>
          </Select>
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Select
            label="Tipo Recurso"
            name="tiporecurso"
            value={values.tiporecurso}
            id="tiporecurso"
            onChange={onChange}
            disabled={habilitado}
            ref={cmbTipoRecurso}
          >
            <option value=""> Seleccione</option>
            <option value="0"> Nornal</option>
            <option value="1">Ordinario</option>
            <option value="2">Fides</option>
            <option value="3">LAE</option>
            <option value="4">Institucion</option>
          </Select>
        </div>
      </div>
      {visibleBtn === "visible" && (
        <div className="col-12 m-0 p-0 d-flex justify-content-end gap-2">
          <PrimaryButton
            icon="fa-plus"
            disabled={botones.incluir}
            onClick={onBotones(1)}
          >
            Incluir
          </PrimaryButton>
          <InfoButton
            icon="fa-eye"
            disabled={botones.consultar}
            onClick={onBotones(4)}
          >
            Consultar
          </InfoButton>
          <WarningButton
            icon="fa-edit"
            disabled={botones.modificar}
            onClick={onBotones(2)}
          >
            Modificar
          </WarningButton>
          <DangerButton
            icon="fa-trash-alt"
            disabled={botones.eliminar}
            onClick={onBotones(3)}
          >
            Eliminar
          </DangerButton>
        </div>
      )}
      <div
        className="col-12 m-0 p-0 d-flex justify-content-end gap-2"
        style={{
          visibility: visibleBtn === "visible" ? "collapse" : "visible",
        }}
      >
        <SuccessButton
          disabled={botones.aceptar}
          onClick={onBotones(5)}
          ref={btnAcepta}
        >
          Aceptar
        </SuccessButton>
        <DangerButton
          disabled={botones.cancelar}
          onClick={onBotones(6)}
          ref={btnCancela}
        >
          Cancelar
        </DangerButton>
      </div>

      <CatalogoPlanCuenta
        show={catalogoCuenta}
        onHideCancelar={() => {
          setCatalogoCuenta(false);
        }}
        onHideAceptaCatalogo={onCatalogoPlanCuenta}
      />

      <Dimmer active={activate}></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaCatalogoCuentaContable;
